<template>
  <div class="dashboard">
    <h1 class="mb-4">{{ $t('dashboard.title') }}</h1>
    
    <div class="row">
      <div class="col-md-4">
        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title">{{ $t('dashboard.credits_card.title') }}</h5>
            <h2 class="card-text">{{ creditsDisplay }}</h2>
            <p class="text-muted">{{ $t('dashboard.credits_card.text') }}</p>
            <router-link to="/credits" class="btn btn-primary">{{ $t('dashboard.credits_card.btn') }}</router-link>
          </div>
        </div>
      </div>
      
      <div class="col-md-4">
        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title">{{ $t('dashboard.process_card.title') }}</h5>
            <h2 class="card-text" style="visibility: hidden;">-</h2>
            <p class="card-text">{{ $t('dashboard.process_card.text') }}</p>
            <router-link to="/invoice" class="btn btn-primary">{{ $t('dashboard.process_card.btn') }}</router-link>
          </div>
        </div>
      </div>
      
      <div class="col-md-4" v-if="isAdmin">
        <div class="card mb-4">
          <div class="card-body">
            <h5 class="card-title">{{ $t('dashboard.users_card.title') }}</h5>
            <h2 class="card-text" style="visibility: hidden;">-</h2>
            <p class="card-text">{{ $t('dashboard.users_card.text') }}</p>
            <router-link to="/users" class="btn btn-primary">{{ $t('dashboard.users_card.btn') }}</router-link>
          </div>
        </div>
      </div>
    </div>
    
    <div class="row mt-4">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5 class="mb-0">{{ $t('dashboard.recent_transactions.title') }}</h5>
          </div>
          <div class="card-body">
            <div v-if="loading" class="text-center py-3">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
            
            <div v-else-if="transactions.length === 0" class="text-center py-3">
              <p>{{ $t('dashboard.recent_transactions.no_data') }}</p>
            </div>
            
            <div v-else class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>{{ $t('dashboard.table.date') }}</th>
                    <th>{{ $t('dashboard.table.type') }}</th>
                    <th>{{ $t('dashboard.table.amount') }}</th>
                    <th>{{ $t('dashboard.table.user') }}</th>
                    <th>{{ $t('dashboard.table.time') }}</th>
                    <th>{{ $t('dashboard.table.reference') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="transaction in recentTransactions" :key="transaction.id">
                    <td>{{ formatDate(transaction.created_at) }}</td>
                    <td>
                      <span 
                        :class="transaction.transaction_type === 'purchase' ? 'badge bg-success' : 'badge bg-warning'"
                      >
                        {{ transaction.transaction_type === 'purchase' ? $t('dashboard.table.purchase') : $t('dashboard.table.usage') }}
                      </span>
                    </td>
                    <td>{{ transaction.amount }}</td>
                    <td>{{ transaction.user_email }}</td>
                    <td>{{ Math.round(transaction.processing_time || 0) }}s</td>
                    <td>{{ transaction.payment_reference }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div class="text-end mt-3">
              <router-link to="/credits" class="btn btn-outline-primary btn-sm">{{ $t('dashboard.recent_transactions.view_all') }}</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Dashboard',
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('auth', ['isAdmin', 'companyCredits', 'creditsDisplay']),
    ...mapGetters('credits', ['allTransactions']),
    
    transactions() {
      return this.allTransactions || []
    },
    
    recentTransactions() {
      return this.transactions.slice(0, 5)
    }
  },
  methods: {
    ...mapActions('credits', ['fetchTransactions']),
    
    formatDate(dateString) {
      const date = new Date(dateString)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString()
    },
    
    async loadTransactions() {
      this.loading = true
      try {
        await this.fetchTransactions()
      } catch (error) {
        console.error('Failed to fetch transactions:', error)
      } finally {
        this.loading = false
      }
    }
  },
  mounted() {
    this.loadTransactions()
  }
}
</script>